export const REQUEST = '_REQUEST';
export const SUCCESS = '_SUCCESS';
export const FAIL = '_FAIL';
export const RESET = '_RESET';



// WEBPACK FOOTER //
// ./src/libs/ApiActions/constants.js